import { CultureInfo } from '../culture-info.model';
import { CultureInfoIt } from './it';

/**
 * @ignore
 */
export const CultureInfoItVA: CultureInfo = {
  name: 'it-VA',
  displayName: 'italiano (Città del Vaticano)',
  iso3LanguageCode: 'ita',
  iso2LanguageCode: 'it',
  ietfLanguageTag: 'it-VA',
  parent: CultureInfoIt
};
